module.exports = __webpack_public_path__ + "_assets/img/store-a.f70305ec.svg";